import {
  FileText,
  ChartColumn,
  Shield,
  Scale,
  GraduationCap,
  Megaphone,
} from "lucide-react";

import { Card, CardContent } from "@/app/_module/components/ui/card";

import type { ResourceCategory } from "../types/types";

interface CategoryOverviewProps {
  categories: ResourceCategory[];
  onCategorySelect: (categoryId: string) => void;
  selectedCategoryId?: string;
}

const iconMap = {
  FileText,
  ChartColumn,
  Shield,
  Scale,
  GraduationCap,
  Megaphone,
};

// Map category names to icon components
const getIconForCategory = (name: string) => {
   // Debug log
  
  switch (name.toLowerCase()) {
    case "applications":
    case "forms":
    case "application forms":
      return FileText;
    case "illustrations":
    case "charts":
    case "presentations":
      return ChartColumn;
    case "underwriting":
    case "underwriting guidelines":
      return Shield;
    case "compliance":
    case "compliance documents":
    case "legal":
      return Scale;
    case "training":
    case "training materials":
    case "education":
      return GraduationCap;
    case "marketing":
    case "marketing materials":
    case "promotional":
      return Megaphone;
    default:
      return FileText;
  }
};

export const CategoryOverview = function({
  categories,
  onCategorySelect,
  selectedCategoryId,
}: CategoryOverviewProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {categories.map((category) => {
        const IconComponent = getIconForCategory(category.name);
        const isSelected = selectedCategoryId === category.id;

        return (
          <Card
            key={category.id}
            className={`cursor-pointer hover:shadow-md transition-all ${
              isSelected ? "ring-2 ring-primary shadow-md bg-primary/10" : ""
            }`}
            onClick={() => onCategorySelect(category.id)}
          >
            <CardContent className="p-4 text-center">
              <div className="flex justify-center mb-2">
                <IconComponent className={`h-8 w-8 ${isSelected ? "text-primary" : "text-primary/80"}`} />
              </div>
              <h3 className={`font-medium text-sm ${isSelected ? "text-primary" : ""}`}>{category.name}</h3>
              <p className="text-xs text-muted-foreground mt-1 line-clamp-2">
                {category.description}
              </p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};